/* 🤖 this file was generated by svg-to-ts */
export const matIconPersonalVideo: {
  name: 'personal-video';
  data: string;
} = {
  name: 'personal-video',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2zm0 14H3V5h18v12z"/></svg>`
};
